import { render, staticRenderFns } from "./liaisonDialog.vue?vue&type=template&id=03f797f6&scoped=true"
import script from "./liaisonDialog.vue?vue&type=script&lang=js"
export * from "./liaisonDialog.vue?vue&type=script&lang=js"
import style0 from "./liaisonDialog.vue?vue&type=style&index=0&id=03f797f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f797f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03f797f6')) {
      api.createRecord('03f797f6', component.options)
    } else {
      api.reload('03f797f6', component.options)
    }
    module.hot.accept("./liaisonDialog.vue?vue&type=template&id=03f797f6&scoped=true", function () {
      api.rerender('03f797f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/list/components/liaisonDialog.vue"
export default component.exports